import FlightsCarsPackagesGridContainerMobile from '../../../../components/containers/FlightsCarsPackagesGridContainerMobile';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresFlightsCarsPackagesGrid';

const cmpConfig = {
  name: 'flights-cars-packages-grid--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FlightsCarsPackagesGridContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
